import React, { useState, useEffect } from "react"
import InputField from "../../../../components/InputField"
import Button from "../../../../components/Button"
import { useSelector } from "react-redux"
import { useHistory } from "react-router"
import "./AddSubCategory.scss"
import Select from "react-select"
import Toast from "components/Toast"
import customSelectStyles from "components/CustomSelect/CustomSelectStyle"
import { getAllCategories, getAllSubCategoriesInfo, saveSubCategory } from "core/services/api/billingService"


function AddSubCategory() {
  const history = useHistory()
  const readOnly = useSelector((state: any) => state?.user?.readOnly)
  const [formData, setFormData] = useState({ category: '', subCategory: '' });
  const [dropdownCategories, setDropdownCategories] = useState<any>();
  const [displayToast, toggleToast] = useState<any>()
  const [error, setError] = useState('');
  const [data, setData] = useState<any>();

  useEffect(() => {
    getAllSubCategoriesInfo().then((res: any) => {
      const namesByType: any = {};
      res?.forEach((item: any) => {
        const { type, name } = item;
        if (!namesByType[type]) {
          namesByType[type] = [];
        }
        namesByType[type].push(name);
      });
      setData(namesByType)
    }).catch((err: any) => {
      console.log(err, "Err");
    })
  }, [])

  useEffect(() => {
    getAllCategories().then((res: any) => {
      const result = res?.map((item: any) => {
        return {
          label: item,
          values: item
        }
      })
      setDropdownCategories(result);
    }).catch((err: any) => {
      console.log(err, "Err");
    })

  }, [])

  const handleSave = () => {
    // Perform save logic here
    if (data[formData?.category]?.map((e: any) => e?.toLowerCase())?.includes(formData?.subCategory?.toLowerCase())) {
      toggleToast({
        type: "error",
        text: 'Sub category already exists',
      })
    } else {
      const values = {
        type: formData?.category,
        name: formData?.subCategory
      }
      saveSubCategory(values)
        .then((res: any) => {
          console.log(res);
          toggleToast({
            type: "success",
            text: 'Sub Category Data Added Successfully',
          })
        })
        .catch((err: any) => {
          console.log(err, "err");
          toggleToast({ text: `Unable to Add SubCategory Details`, type: "error" })
          // Reset the input fields
          setError('');
        })
    }
  }

  const handleCancel = () => {
    // Reset the input fields
    setFormData({ category: '', subCategory: '' });
    setError('');
  };

  return (
    <div className="add-new-referral-container">
      {/* <div className="add-new-referral-heading">
        <div
          className="approval-back-image"
          onClick={() => {
            history.goBack()
          }}
        >
          <img
            src={'../../../assets/images/back-icon.svg'}
            height={'60px'}
            width={'60px'}
            alt="back button"
            className="back_button"
          />
        </div>
        <div className="add-new-text">Add Sub Category </div>
      </div> */}
      <div className="add-new-referral-details">
        <div className="row nameDetails">
          <div className="col-2">
            <label className="textlabel">Category: </label>
          </div>
          <div className="col-3">
            <Select
              styles={customSelectStyles()}
              onChange={(e: any) => {

                setFormData({
                  ...formData,
                  category: e?.label,
                })
              }}
              value={dropdownCategories?.filter(
                (value: any) => value?.label === formData?.category
              )}
              options={dropdownCategories}
              isDisabled={readOnly}
            />
          </div>
        </div>
        <div className="row nameDetails">
          <div className="col-2">
            <label className="textlabel">SubCategory:</label>
          </div>
          <div className="col-3">
            <InputField
              placeholder="Name"
              value={formData?.subCategory}
              handleChange={(e) =>
                setFormData({
                  ...formData,
                  subCategory: e?.target?.value,
                })
              }
              readOnly={readOnly}
            // errorMsg={formErrors?.name}
            />

          </div>
        </div>

        <div className="button-alignment">
          <div>
            <Button
              text="Cancel"
              type={"button"}
              disabled={readOnly}
              outline={true}
              onClick={() => {
                history.push("/home")
              }}
              id="cancel"
            />
          </div>
          <div>
            <Button
              disabled={readOnly}
              onClick={() => handleSave()}
              text="Save" type="submit" id="save" />
          </div>
        </div>
      </div>
      {displayToast && (
        <Toast
          textMessage={displayToast?.text}
          onClose={() => {
            if (displayToast?.type === "error") {
              toggleToast(false)
            } else {
              toggleToast(false)
              setFormData({ category: '', subCategory: '' });
            }
          }}
          onCloseText={"Close"}
          onClickText={null}
          onClick={() => history.push("/ContactReferrals")}
          type={displayToast?.type}
        />
      )}
    </div>
  )
}
export default AddSubCategory
